export interface StyleClosetTheme {
  colors: { [key in keyof typeof colors]: string };
  breakpoints: { [key in keyof typeof breakpoints]: string };
}

const colors = {
  primary: '#2d2f8f',
  secondary: '#ee2737',
  accent: '#f6f8fc',
  border: '#dfe3ee',
  text: '#191922',
  muted: '#777',
  black: '#0c0b10',
};

const breakpoints = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1025px',
};

const theme: StyleClosetTheme = {
  colors,
  breakpoints,
};

export { theme };
